import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { PaymentOptions } from '@/components/PaymentOptions';

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [formData, setFormData] = useState({ name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [showPayment, setShowPayment] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await register(formData.email, formData.password, formData.name);
      if (result.status === 'pending') {
        setShowPayment(true);
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al registrarse');
    } finally {
      setLoading(false);
    }
  };

  if (showPayment) {
    return (
      <div className="min-h-screen bg-[#020402] flex items-center justify-center px-4 py-8 grid-overlay">
        <PaymentOptions
          title="REGISTRO EXITOSO"
          subtitle="Tu cuenta ha sido creada. Realiza el pago de tu membresía para ser activado."
          userName={formData.name}
          userEmail={formData.email}
          onBack={() => navigate('/login')}
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#020402] flex items-center justify-center px-6 py-12 grid-overlay">
      <div className="w-full max-w-md">
        <div className="glass-panel rounded-lg p-8 alien-glow" data-testid="register-form">
          <div className="flex justify-center mb-8">
            <img src="/logo.png" alt="Trading Alienígena Logo" className="w-16 h-16 object-contain" />
          </div>
          <h2 className="text-3xl font-bold text-center mb-2 text-emerald-50" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
            CREAR CUENTA
          </h2>
          <p className="text-center text-emerald-100/60 mb-8">Únete a la comunidad de Trading Alienígena</p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="name" className="text-emerald-100">Nombre</Label>
              <Input id="name" type="text" placeholder="Tu nombre" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required className="bg-black/50 border-emerald-500/30 text-emerald-50 focus:border-emerald-500 placeholder:text-emerald-500/30" data-testid="register-name-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="email" className="text-emerald-100">Email</Label>
              <Input id="email" type="email" placeholder="tu@email.com" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} required className="bg-black/50 border-emerald-500/30 text-emerald-50 focus:border-emerald-500 placeholder:text-emerald-500/30" data-testid="register-email-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-emerald-100">Contraseña</Label>
              <Input id="password" type="password" placeholder="••••••••" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} required minLength={6} className="bg-black/50 border-emerald-500/30 text-emerald-50 focus:border-emerald-500 placeholder:text-emerald-500/30" data-testid="register-password-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-emerald-500 text-black hover:bg-emerald-400 font-bold uppercase tracking-wider py-6" data-testid="register-submit-btn">
              {loading ? 'Cargando...' : 'Crear Cuenta'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-emerald-100/60">
              ¿Ya tienes cuenta?{' '}
              <Link to="/login" className="text-emerald-400 hover:text-emerald-300 font-semibold" data-testid="register-login-link">Inicia sesión aquí</Link>
            </p>
          </div>
          <div className="mt-4 text-center">
            <Link to="/" className="text-emerald-400/70 hover:text-emerald-400 text-sm">← Volver al inicio</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
